<template>
  <div class="searchingTag">
    <div class="setBtnContainer">
      <button class="btn SetBtn" @click="setTag">Set Tag</button>
    </div>
    <div class="searchContainer">
      <div class="searchProduct">
        <p class="srchLabel">Search Records</p>
        <p class="productInput">
          <input
            class="form-control srch-input"
            v-model="keywordInput"
            placeholder="Keyword"
            @keydown="srchKeyDown"
          />
          <span class="srchBtn" @click="srchProducts"
            ><svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9 0C4.03672 0 0 4.03672 0 9C0 13.9633 4.03692 18 9.00021 18C10.6999 17.9997 12.358 17.5156 13.7842 16.6134L18.293 21.1222L21.1212 18.294L16.6125 13.7853C17.5152 12.3589 17.9996 10.7002 18 9C18 4.03672 13.9633 0 9 0ZM4 9C4 6.24328 6.24328 4 9 4C11.7567 4 14 6.24328 14 9C14 11.7567 11.7567 14 9 14C6.24328 14 4 11.7567 4 9Z"
                fill="#858585"
              ></path></svg
          ></span>
        </p>
        <p class="productInput">
          <input
            class="form-control srch-input"
            v-model="manufacturerInput"
            placeholder="Manufacturer"
            @keydown="srchKeyDown"
          />
          <span class="srchBtn" @click="srchProducts"
            ><svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9 0C4.03672 0 0 4.03672 0 9C0 13.9633 4.03692 18 9.00021 18C10.6999 17.9997 12.358 17.5156 13.7842 16.6134L18.293 21.1222L21.1212 18.294L16.6125 13.7853C17.5152 12.3589 17.9996 10.7002 18 9C18 4.03672 13.9633 0 9 0ZM4 9C4 6.24328 6.24328 4 9 4C11.7567 4 14 6.24328 14 9C14 11.7567 11.7567 14 9 14C6.24328 14 4 11.7567 4 9Z"
                fill="#858585"
              ></path></svg
          ></span>
        </p>
      </div>
      <div class="searchTag">
        <p class="srchLabel">Search for Tags</p>
        <input class="form-control" v-model="srchTags" @keyup="searchingTags" />
        <div
          class="form-control suggestion"
          v-if="this.tagSuggestion.length && this.srchTags.length"
        >
          <p
            v-for="(suggestion, index) in this.tagSuggestion"
            :key="index"
            class="suggestionItem"
            @click="selectTag(suggestion)"
          >
            <span
              v-for="(snip, i) in getIndicesOf(suggestion.tagName)"
              :key="i"
              :class="{ highlight: i % 2 != 0 }"
            >
              <span>{{ snip }}</span>
            </span>
            ({{ suggestion.tagType }})
          </p>
        </div>
      </div>
    </div>
    <ProductSearchResults
      :searchResults="searchResults"
      :totalResultsCount="10"
      @select="selectProduct"
    />
  </div>
</template>

<script>
import { axiosClient } from "@/axios-client";
import ProductSearchResults from "@/components/global/product-search-results.vue";

export default {
  name: "SearchTag",

  components: {
    ProductSearchResults,
  },
  mounted() {
    this.$root.$on("openedSearchTag", (val) => {
      this.selectedResult = val;
      this.keywordInput = this.selectedResult.productName;
      this.manufacturerInput = this.selectedResult.manufacturerName;
      this.srchProducts();
    });
  },

  methods: {
    groupByKey(array, key) {
      const keyFn = key instanceof Function ? key : (obj) => obj[key];
      return array.reduce((objectsByKeyValue, obj) => {
        const value = keyFn(obj);
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
      }, {});
    },
    populateSearchData(data) {
      this.searchResultsNum = data.length;
      this.searchResults = [];
      let countryGroups = this.groupByKey(data, (obj) => obj.source);

      for (let countryGroup of Object.entries(countryGroups)) {
        this.searchResults.push(countryGroup);
      }
      if (this.selectedResult._id) {
        let selectedGroup = this.searchResults.filter(
          (item) => item[0] == this.selectedResult.source
        );
        let otherGroup = this.searchResults.filter(
          (item) => item[0] != this.selectedResult.source
        );
        if (selectedGroup.length) {
          let others = selectedGroup[0][1].filter(
            (item) => item._id != this.selectedResult._id
          );
          selectedGroup[0][1] = [this.selectedResult, ...others];
        } else {
          selectedGroup = [[this.selectedResult.source, [this.selectedResult]]];
        }
        this.searchResults = [...selectedGroup, ...otherGroup];
      }
    },
    srchProducts() {
      this.$store.commit("productsAreLoading");
      axiosClient
        .post("v1/search/registrations", {
          keywordQuery: this.keywordInput,
          manufacturerName: this.manufacturerInput,
        })
        .then((response) => {
          const registrations = response.data.records || response.data;
          this.populateSearchData(registrations);
          this.$store.commit("productsLoaded");
        })
        .catch((err) => console.log(err));
    },
    srchKeyDown(e) {
      if (e.keyCode == 13) this.srchProducts();
    },
    searchingTags() {
      if (this.srchTags) {
        axiosClient
          .get(
            "v1/search/registrations/search-tags/autocomplete?query=" +
              this.srchTags
          )
          .then((response) => {
            this.tagSuggestion = [];
            this.tagSuggestion.push(...response.data.suggestions);
          })
          .catch((err) => console.log(err));
      }
    },
    clearSuggestion() {
      this.tagSuggestion = [];
    },
    seperating(name) {
      return name.split(this.srchTags);
    },
    getIndicesOf(str) {
      var searchStr = this.srchTags;
      var originStr = str;
      var searchStrLen = searchStr.length;
      if (searchStrLen == 0) {
        return [];
      }
      var startIndex = 0,
        index,
        indices = [],
        result = [];
      str = str.toLowerCase();
      searchStr = searchStr.toLowerCase();
      while ((index = str.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        result.push(originStr.slice(startIndex, index));
        result.push(originStr.slice(index, index + searchStrLen));
        startIndex = index + searchStrLen;
      }
      result.push(originStr.slice(startIndex));
      return result;
    },
    selectTag(selected) {
      this.srchTags = selected.tagName;
      this.selectedTag = selected;
      this.clearSuggestion();
    },
    setTag() {
      if (!this.selectedTag.tagType) {
        const customTag = {
          tagName: this.srchTags,
          tagType: "manufacturer",
        };
        this.selectedTag = customTag;
      }
      if (this.selectedProducts.length > 0) {
        this.$store.commit("productsAreLoading");
        axiosClient
          .post("v1/tags/setting-tags", {
            registrationIds: this.selectedProducts,
            selectedTag: this.selectedTag,
          })
          .then((response) => {
            if (response) {
              axiosClient
                .post("v1/search/registrations", {
                  keywordQuery: this.keywordInput,
                  manufacturerName: this.manufacturerInput,
                })
                .then((res) => {
                  const registrations = res.data.records || res.data;
                  this.populateSearchData(registrations);
                  this.$store.commit("productsLoaded");
                })
                .catch((errr) => console.log(errr));
            }
          })
          .catch((err) => console.log(err));
      } else {
        alert("No registration selected!");
      }
      this.selectedTag = {};
    },
    selectProduct(product) {
      const find = this.selectedProducts.find((item) => item == product._id);
      if (find) {
        const afterRemove = this.selectedProducts.filter(
          (item) => item != product._id
        );
        this.selectedProducts = afterRemove;
      } else {
        this.selectedProducts.push(product._id);
      }
    },
  },
  data() {
    return {
      keywordInput: "",
      manufacturerInput: "",
      srchTags: "",
      searchResultsNum: 0,
      searchResults: [],
      tagSuggestion: [],
      selectedTag: {},
      selectedProducts: [],
      selectedResult: {},
    };
  },
};
</script>

<style lang="scss">
.srch-input {
  &::placeholder {
    font-style: italic;
  }
}
.highlight {
  background-color: lightblue;
}
.suggestionItem {
  width: 100%;
  margin: 0px;
  padding-bottom: 10px;
}
.suggestionItem:hover {
  background-color: #fafafa;
}
.suggestion {
  height: auto;
  position: absolute;
  z-index: 9999;
  max-width: calc(100% - 3rem);
  padding: 0px;
}
.searchingTag {
  background-color: #f8f8f8;
  overflow: auto;
}
.searchContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.searchProduct,
.searchTag {
  width: 45%;
  padding: 20px;
  position: relative;
}
.srchLabel {
  font-size: 20px;
}
.SetBtn {
  background-color: #fcaf05;
  margin: 20px;
  margin-bottom: 0px;
  font-size: 20px;
}
.setBtnContainer {
  text-align: right;
}
.productInput {
  position: relative;
  font-size: 20px;
}
.srchBtn {
  background-color: white;
  padding-left: 5px;
  position: absolute;
  right: 5px;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  &:hover {
    svg path {
      fill: #fcaf05;
    }
  }
}
</style>
